module.exports = __webpack_public_path__ + "static/media/sign-up-macbook.80c29cfd.png";